import { T, useTranslate } from '@tolgee/react';
import styled from 'styled-components';

import theme from '../../../assets/theme';
import HybridForm from '../HybridForm/HybridForm';

const QuotesForm = () => {
  const { t } = useTranslate();

  return (
    <PageContainer>
      <h1 style={{ textAlign: 'center', marginBottom: '20px' }}>
        <T
          keyName="request_curipod_quote_title"
          defaultValue="Request a Curipod quote!"
        />
      </h1>
      <h4 style={{ textAlign: 'center', marginBottom: '20px' }}>
        <T
          keyName="fill_out_form_quote_description"
          defaultValue="Fill out this form to get a quote for Curipod's school plan!"
        />
      </h4>
      <HybridForm
        typeformUrl="https://9uq31r57i3q.typeform.com/to/rdHtD0FA"
        metricEventNamePrefix="Quotes"
        showTypeformEnding={true}
      />
    </PageContainer>
  );
};

const PageContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0;
  background: ${theme.colors.background};
`;

export default QuotesForm;
